import PhotoSectionScreen from './PhotoSectionScreen';
import i18n from '../utils/i18n';
import './ExternalPhotosScreen.scss';

const ExternalPhotosScreen = () => {
  return (
    <div className="exterior-section">
      <h1>{i18n.get('exterior.title', 'Fotos exteriores')}</h1>
      <p>{i18n.get('exterior.sub_title', 'Haz clic en una parte del vehículo para iniciar la toma de fotos de las cuatro zonas exteriores. Al abrir la cámara, verá ejemplos que le servirán de guía en cada paso')}</p>
      <p><b>{i18n.get('exterior.select_zone', 'Selecciona una parte del vehículo para iniciar:')}</b></p>
      <PhotoSectionScreen idSection="EXTERIOR" link="exterior" />
    </div>
  );
};

export default ExternalPhotosScreen;